<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-on="http://www.w3.org/1999/xhtml">
    <div class="login-bg-main-section register-main-section width-full float-l" id="login-main-hr">
        <div v-if="currentEnvironment" class="notification-block notification-block-top">
            <div role="alert" aria-live="polite" aria-atomic="true" class="alert alert-primary alert-dismissible">
                <div class="scroll-left">
                    <p>This is Test Environment !</p>
                </div>
            </div>
        </div>
        <div class="login-left-section float-l"> <!--left section-->
            <router-link v-bind:to="{ path:'/'}"> <img src="/static/images/vvg-home-logo.png" alt="Velocity Truck Center"> </router-link>
            <!--<router-link v-if="idetify_flag == ''" v-bind:to="{ path:'/'}"> <img src="/static/images/vvg-home-logo.png" alt="Velocity Truck Center"> </router-link>
            <a v-if="idetify_flag != ''" :href="idetify_flag"> <img src="/static/images/vvg-home-logo.png" alt="Velocity Truck Center"> </a>-->
        </div> <!--left section-->
        <div class="register-right-main-section width-full float-l"> <!--right section-->
            <form class="cmxform" id="form" name="form">

                <div class="register-form-main">
                    <h2> Register Here </h2>
                    <div class="row">


                        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                            <label for="uname" class="registerlabel">Dayforce Id<span class="text-danger">*</span></label>
                            <input id="username" type="text" placeholder="" name="uname" required v-model="username">
                            <font class="text-danger">{{frontendErrors.username}}</font>
                        </div>

                        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                            <label for="email" class="registerlabel">Email<span class="text-danger">*</span></label>
                            <input id="email" type="text" placeholder="" name="email" required v-model="email">
                            <font class="text-danger">{{frontendErrors.email}}</font>
                        </div>
                        <div class="clearfix"></div>
                        <!--<div class="col-12 col-sm-6 col-md-6 col-lg-6">
                            <label for="mname">Middle Name</label>
                            <input id="middleName" type="text" placeholder="" name="mname" required v-model="middleName">
                            <font class="text-danger">{{frontendErrors.middleName}}</font>
                        </div>-->                        
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                            <label for="fname" class="registerlabel">First Name<span class="text-danger">*</span></label>
                            <input id="firstName" type="text" placeholder="" name="fname" required v-model="firstName">
                            <font class="text-danger">{{frontendErrors.firstName}}</font>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                            <label for="lname" class="registerlabel">Last Name<span class="text-danger">*</span></label>
                            <input id="lastName" type="text" placeholder="" name="lname" required v-model="lastName">
                            <font class="text-danger">{{frontendErrors.lastName}}</font>
                        </div>
                        <div class="clearfix"></div>
                        <!--<template v-if="availableInSSO === true">
                            <div class="col-12 col-sm-6 col-md-12 col-lg-12">
                                <label class="error">You are already registered in centralized system with different application, 
                                    so you can user your current password or you can change centralized system's password using forgot password to login with this system after registering here.</label>
                                <br/><br/>
                            </div>
                        </template>
                        <template v-else>-->
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                            <label for="pwd" class="registerlabel">Password<span class="text-danger">*</span></label>
                            <input id="password" type="password" placeholder="" name="pwd" required v-model="password">
                            <font class="text-danger">{{frontendErrors.password}}</font>
                        </div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                            <label for="cpwd" class="registerlabel">Confirm Password<span class="text-danger">*</span></label>
                            <input id="cpassword" type="password" placeholder="" name="cpwd" required v-model="cpassword">
                            <font class="text-danger">{{frontendErrors.cpassword}}</font>
                        </div>
                        <!--</template>-->
                        <div class="clearfix"></div>
                        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                            <label for="locations" class="registerlabel">State<span class="text-danger">*</span></label>
                            <v-select class=""
                                      v-model="locationIdSearch"
                                      @input="changedValueLocation()"
                                      name="locationIdSearch"
                                      id="locationIdSearch"
                                      label="text"
                                      :searchable="false"
                                      :filterable="false"
                                      :options="locationArr"
                                      placeholder="Select State" required>
                            </v-select>
                            <font class="text-danger">{{frontendErrors.locationIdSearch}}</font>
                        </div>
                        <!--<div class="col-12 col-sm-6 col-md-6 col-lg-6">
                            <label for="profileImages">Select image to upload:</label>
                            <input type="file" name="profileImages" id="browse" ref="profileImages">
                        </div>-->
                        <div class="clearfix"></div>

                        <!--<div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                                <vue-croppie
                                    ref="croppieRef"
                                    id="vuecrop"
                                    :viewport="{width:276, height: 312, type: 'square'}"
                                    :boundary="{ width: 286, height: 322 }"
                                    :enableResize="false"
                                    @result="result"
                                    @update="update" ></vue-croppie>
                            </div>
                            <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                                <button class="btn-croppie" id="rotateAnti" type="button" @click="rotate(-90)" title="Rotate Left"><i aria-hidden="true" class="fa fa-repeat"></i></button>
                                <button class="btn-croppie" id="rotateClock" type="button" @click="rotate(90)" title="Rotate Right"><i aria-hidden="true" class="fa fa-undo"></i></button>
                                <button class="btn-croppie" id="crop" type="button" @click="crop()" title="Crop"><i class="fa fa-crop" aria-hidden="true"></i></button>
                                <br/>
                                <img v-bind:src="cropped" width="200"/>
                                <font class="text-danger">{{cropError}}</font>
                            </div>
                        </div>-->

                        <!--<div class="col-12 col-sm-12 col-md-12 col-lg-12">
                            <button @click="bind()">Bind</button>
                        </div>-->

                        <div class="col-12 col-sm-6 col-md-6 col-lg-6">
                            <font class=""> <label id="errorMsg" class="error text-danger"></label><br> </font>
                        </div>
                        <div v-if="registerButton == true" class="btm-login-section btm-register-section col-12 float-l">
                            <div class="btn-login-main float-l col-12">
                                <div class="row">  
                                    <button type="submit" class="register_button hvr-sweep-to-right-red" v-on:click.prevent="submitRegistrationForm()">Register Now</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </form>
        </div> <!--right section-->
    </div>
</template>

<script>
    import EventBus from './event-bus';
    import {loginUrl, configs} from '../config';
    import SessioMixin from '../mixins/sessionmixin';
    var self;
    import {HTTP} from '../http-common';
    import vSelect from 'vue-select';
    //import Autocomplete from 'vuejs-auto-complete'
    import Vue from 'vue';
    import VueCroppie from 'vue-croppie';

    Vue.use(VueCroppie);
    export default {
        name: 'Register',
        props: [''],
        components: {
            'v-select': vSelect,
        },
        mixins: [SessioMixin],
        data() {
            return {
                idetify_flag: "",
                availableInSSO: false,
                registerButton: true,
                userRegistered: false,
                error: '',
                firstName: '',
                /*middleName: '',*/
                lastName: '',
                email: '',
                username: '',
                password: '',
                cpassword: '',
//                errors: {},
                frontendErrors: {
                    firstName: '',
                    /*middleName: '',*/
                    lastName: '',
                    email: '',
                    username: '',
                    password: '',
                    cpassword: '',
                    locationIdSearch: '',
                },
                backendErrors: [],
                locationData: '',
                locationArr: [],
                locationIdSearch: '',

                cropped: null,
                profileImages: [],
                croppedProfileImage: '',
                isCropped: false,
                isFileUploaded: false,
                cropError: '',

            }
        },
        mounted: function () {
            self = this;
            /* localStorage.clear(); */
            self.getBuildVersion();
            $('#main-header').hide();
            $('#main-footer').hide();
            $('html,body,#app').css({
                //height: "100%"
            });
            self.idetify_flag = (self.$route.query.identify === null || typeof (self.$route.query.identify) === "undefined" || self.$route.query.identify == '') ? '' : self.$route.query.identify;

            /*if ($(".login-form-right-section").height() > $(window).height()) {
             $("#login-main-hr").height($(".login-form-right-section").height());
             } else {*/
            $("#login-main-hr").height($(window).height());
            /*}*/
            /*$("#login-main-hr").css({
             height:
             });*/
            $("#firstName").on('keyup', function () {
                self.frontendErrors.firstName = '';
            });
            /*$("#middleName").on('keyup', function () {
             self.frontendErrors.middleName = '';
             });*/
            $("#lastName").on('keyup', function () {
                self.frontendErrors.lastName = '';
            });
            $("#email").on('keyup', function () {
                if (self.availableInSSO === true) {
                    self.frontendErrors.email = '';
                }
            });
            $("#username").on('keyup', function () {
                self.frontendErrors.username = '';
            });
            $("#password").on('keyup', function () {
                self.frontendErrors.password = '';
            });
            $("#cpassword").on('keyup', function () {
                self.frontendErrors.cpassword = '';
            });
            $("#locationIdSearch").on('keyup', function () {
                self.frontendErrors.locationIdSearch = '';
            });
            $("#vuecrop").hide();
            $("#rotateAnti").hide();
            $("#rotateClock").hide();
            $("#crop").hide();

            /*self.$refs.croppieRef.bind({
             url: '',
             });*/

            $("#browse").on('change', function () {
                self.readFile(this);
                $("#vuecrop").show();
                $("#rotateAnti").show();
                $("#rotateClock").show();
                $("#crop").show();
            });
            self.loadLocations();
        },
        watch: {
            username: function (username) {
                $(".register_button").prop("disabled", false);
                self.registerButton = true;
                if (username.length > 2) {
                    var fields = {
                        dayforceid: username,
                    };
                    //console.log(self.username.length);
                    HTTP.post("/getnotregistereduser", fields)
                            .then(function (response) {
                                //console.log("success");
                                // console.log('Request Status : ' + response.data.code);
                                if (response.data.code === 200) {
                                    if (response.data.content.email != null && response.data.content.email != '') {
                                        self.email = response.data.content.email;
                                        $('#email').prop("disabled", true);
                                    } else {
                                        $(".register_button").prop("disabled", true);
                                        self.registerButton = false;
                                        self.$swal(
                                                /*'Email already registered in centralized system.',*/
                                                '',
                                                'Your email is not available in system. ' +
                                                'Please contact HR.',
                                                'error'
                                                );
                                    }
                                    self.firstName = response.data.content.first_name;
                                    self.lastName = response.data.content.last_name;
                                    self.locationIdSearch = {
                                        text: response.data.content.location_name,
                                        value: response.data.content.location_id,
                                    };
                                } else if (response.data.code === 201){
                                    var loginurl = "";
                                    self.frontendErrors.username = response.data.content;
                                    if (self.idetify_flag != "") {
                                        loginurl = self.idetify_flag;
                                    } else {
                                        loginurl = "/login";
                                    }
                                    self.$swal(
                                        /*'Email already registered in centralized system.',*/
                                        '',
                                        'The user is already registered in system. ' +
                                        'You can login with the login details.' + 
                                        '<br/><a href="' + loginurl + '">Click here</a> to login in to the portal.',
                                        'info'
                                    );
                                }
                            })
                            .catch(function (err) {
                                self.firstName = self.email = self.lastName = "";
                                $('#email').prop("disabled", false);
                                self.loadLocations();
                                // console.log('Request Status : ' + err.response.status);
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        //localStorage.removeItem("user_obj");
                                        //localStorage.removeItem("api_token");
                                        //localStorage.removeItem("profile_image");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                    //console.log(JSON.stringify(err.response.data));
                                    self.error = err.response.data.message;
                                }
                            });
                } else {
                    self.firstName = self.email = self.lastName = "";
                    $('#email').prop("disabled", false);
                    self.loadLocations();
                }
            },
            email: function (email) {
                $(".register_button").prop("disabled", false);
                self.registerButton = true;
                if (email.length >= 5) {
                    /*console.log(email);
                     return false;*/
                    var fields = {
                        username: email,
                    };
                    //console.log(self.username.length);
                    HTTP.post("checkemail", fields)
                            .then(function (response) {
                                if (response.data.code === 200) {
                                    self.userRegistered = false;
                                    self.frontendErrors.email = '';
                                    if (response.data.content.id) {
                                        self.availableInSSO = true;
                                        self.$swal(
                                                /*'Email already registered in centralized system.',*/
                                                '',
                                                'You can create a password here for your new account in VVG systems or ' +
                                                'You can enter same password which you are using for other VVG systems.',
                                                'info'
                                                );
                                    }
                                }
                                if (response.data.code === 202) {
                                    self.userRegistered = true; 
                                    self.frontendErrors.email = response.data.content;
                                    var loginurl = "";
                                    if (self.idetify_flag != "") {
                                        loginurl = self.idetify_flag;
                                    } else {
                                        loginurl = "/login";
                                    }
                                    self.$swal(
                                        /*'Email already registered in centralized system.',*/
                                        '',
                                        'The email address is already registered in system. ' +
                                        'You can login with the login details or you can contact admin persion to change email address. ' + 
                                        '<br/><a href="' + loginurl + '">Click here</a> to login in to the portal.',
                                        'info'
                                    );
                                }
                            })
                            .catch(function (err) {
                                self.frontendErrors.email = '';
                                self.userRegistered = self.availableInSSO = false;
                                if (err.response.status == 0) {
                                    //self.error = "Remote server can not be reachable";
                                } else {
                                    //redirect to login page if user not authenticated
                                    if (err.response.status == 401) {
                                        //clear previous data
                                        //localStorage.removeItem("user_obj");
                                        //localStorage.removeItem("api_token");
                                        //localStorage.removeItem("profile_image");
                                        //EventBus.$emit("logged-in", true, "", "");
                                    }
                                    //self.error = err.response.data.message;
                                }
                            });
                } else {
                    self.availableInSSO = false;
                }
            }
        },
        methods: {

            loadLocations() {
                HTTP.post("/getlocation")
                        .then(function (response) {
                            self.locationArr = [];
                            $.each(response.data.content, function (i) {
                                if (response.data.content[i].value != 0) {
                                    if (i == 1) {
                                        self.locationIdSearch = {
                                            value: response.data.content[i].value,
                                            text: response.data.content[i].text,
                                        };
                                    }
                                    self.locationArr.push(response.data.content[i]);
                                }
                            });
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    //localStorage.removeItem("user_obj");
                                    //localStorage.removeItem("api_token");
                                    //localStorage.removeItem("profile_image");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            checkForm: function () {
                /*if (self.availableInSSO === true) {
                 self.password = "123";
                 self.cpassword = "123";
                 }*/
                var checked = true;
                self.frontendErrors.firstName = "";
                /*self.frontendErrors.middleName = "";*/
                self.frontendErrors.lastName = "";
                if (!self.userRegistered) {
                    self.frontendErrors.email = "";
                } else {
                    var loginurl = "";
                    if (self.idetify_flag != "") {
                        loginurl = self.idetify_flag;
                    } else {
                        loginurl = "/login";
                    }
                    self.$swal(
                        /*'Email already registered in centralized system.',*/
                        '',
                        'The email address is already registered in system. ' +
                        'You can login with the login details or you can contact admin persion to change email address. ' + 
                        '<br/><a href="' + loginurl + '">Click here</a> to login in to the portal.',
                        'info'
                    );
                }
                self.frontendErrors.username = "";
                self.frontendErrors.password = "";
                self.frontendErrors.cpassword = "";
                self.frontendErrors.locationIdSearch = "";
                self.cropError = "";


                if (!self.locationIdSearch) {
                    self.frontendErrors.locationIdSearch = "State is required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.firstName) {
                    self.frontendErrors.firstName = "First Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                /*if (!self.middleName) {
                 self.frontendErrors.middleName = "Middle Name Required.";
                 if (checked) {
                 checked = false;
                 }
                 }*/
                if (!self.lastName) {
                    self.frontendErrors.lastName = "Last Name Required";
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.email) {
                    self.frontendErrors.email = 'Email Required';
                    if (checked) {
                        checked = false;
                    }
                } else if (!self.validEmail(self.email)) {
                    self.frontendErrors.email = 'Please Enter Valid Email';
                    if (checked) {
                        checked = false;
                    }
                } else if (self.userRegistered) {
                    self.frontendErrors.email = self.frontendErrors.email;
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.username) {
                    self.frontendErrors.username = 'Dayforce Id Required';
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.password) {
                    self.frontendErrors.password = 'Password Required';
                    if (checked) {
                        checked = false;
                    }
                } else if (self.password.length <= 5) {
                    self.frontendErrors.password = 'Password must be at list six character long';
                    if (checked) {
                        checked = false;
                    }
                }
                if (!self.cpassword) {
                    self.frontendErrors.cpassword = 'Confirm Required';
                    if (checked) {
                        checked = false;
                    }
                }
                if (self.password != self.cpassword) {
                    self.frontendErrors.cpassword = 'Password Does Not Match';
                    if (checked) {
                        checked = false;
                    }
                }
                /*if (self.isFileUploaded == false) {
                 self.cropError = 'Please Upload Image';
                 if (checked) {
                 checked = false;
                 }
                 } else if (self.isCropped == false) {
                 self.cropError = 'Please Crop the Image';
                 if (checked) {
                 checked = false;
                 }
                 }*/
                return checked;
            },

            validEmail: function (email) {
                var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            submitRegistrationForm() {
                console.log("hi hi");
                if (self.checkForm()) {
                    /*if (self.availableInSSO === true) {
                     self.password = "";
                     self.cpassword = "";
                     }*/
                    /*console.log('RegistrationForm');*/
                    var fields = {
                        availableinsso: self.availableInSSO,
                        first_name: self.firstName,
                        /*middle_name: self.middleName,*/
                        last_name: self.lastName,
                        email: self.email,
                        username: self.username,
                        password: self.password,
                        location_id: self.locationIdSearch.value,
                        profile_image: self.croppedProfileImage,
                    };
                    HTTP.post("register", fields)
                            .then(function (response) {
                                if (response.data.status == "success") {
                                    self.userRegistered = false;
                                    self.$swal({
                                        type: 'success',
                                        text: 'User Registered Successfully',
                                        showConfirmButton: false,
                                        timer: 5000,
                                    });
                                    setTimeout(function () {
                                        if (self.idetify_flag != "") {
                                            window.location.replace(self.idetify_flag);
                                        } else {
                                            self.$router.push("/login");
                                        }
                                    }, 5000);
                                } else if(response.data.status ==  'registered-error'){
                                    self.userRegistered = true;
                                    var loginurl = "";
                                    if (self.idetify_flag != "") {
                                        loginurl = self.idetify_flag;
                                    } else {
                                        loginurl = "/login";
                                    }
                                    self.$swal(
                                        /*'Email already registered in centralized system.',*/
                                        '',
                                        'The user is already registered in system. ' +
                                        'You can login with the login details.' + 
                                        '<br/><a href="' + loginurl + '">Click here</a> to login in to the portal.',
                                        'info'
                                    );
                                } else {
                                    console.log(response.data.status);
                                    $("#errorMsg").html(response.data.message);
                                    if (response.data.content.length > 0) {
                                        var err = "";
                                        err += response.data.content + "<br>";
                                        $("#errorMsg").html(err);
                                    }
                                }
                            })
                            .catch(function (err) {
                                self.Registerbtn = "Register";
                                if (err.response.status == 0) {
                                    self.error = "Remote server can not be reachable";
                                } else {
                                    $('#errorMsg').html(err.response.data.message);
                                }
                            });
                }

                //
            }, /*,
             getUser() {
             var getUserdata = {
             'access_token': window.localStorage.getItem('access_token')
             };
             //var access_token = window.localStorage.getItem('access_token');
             axios.post(process.env.ROOT_API + "/user", {
             headers: getUserdata
             })
             .then(function(resp) {
             self.flash(resp.data, 'success', {
             timeout: 3000
             });
             })
             .catch(function(resp) {
             console.log('getUser catch');
             console.log(resp);
             });
             }*/

            readFile(input) {
                var self = this;
                if (input.files && input.files[0]) {
                    self.isFileUploaded = true;
                    var reader = new FileReader();
                    reader.onload = function (e) {
                        self.$refs.croppieRef.bind({
                            url: e.target.result,
                        });
                        console.log(e.target.result);
//                        $('#main-cropper').croppie('bind', {
//                            url: e.target.result
//                        });
                    }
                    reader.readAsDataURL(input.files[0]);
                }
            },

            // CALBACK USAGE
            crop() {
                // Here we are getting the result via callback function
                // and set the result to this.cropped which is being
                // used to display the result above.
                self.isCropped = true;
                let options = {
                    format: 'jpeg',
                    circle: false,
                }
                self.$refs.croppieRef.result(options, (output) => {
                    self.cropped = output;
                    self.croppedProfileImage = self.cropped;
                    self.cropError = "";
                });
            },
            // EVENT USAGE
            result(output) {
                self.cropped = output;
            },
            update(val) {
                /*console.log(val);*/
            },
            rotate(rotationAngle) {
                // Rotates the image
                self.$refs.croppieRef.rotate(rotationAngle);
            },
            changedValueLocation: function () {
                self.frontendErrors.locationIdSearch = '';
            },
        }

    }
</script>


// WEBPACK FOOTER //
// src/components/Register.vue